import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "searchInput", "loading", "searchError",
    "ncDetails", "ncNumber", "ncType", "ncDate", "ncTotal",
    "colppyInvoiceId", "submitButton"
  ]

  static values = {
    patientId: Number,
    searchUrl: String
  }

  connect() {
    this.updateSubmitState()
  }

  handleKeypress(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.searchCreditNote()
    }
  }

  async searchCreditNote() {
    const nroFactura = this.searchInputTarget.value.trim()
    if (!nroFactura) return

    this.loadingTarget.style.display = "block"
    this.searchErrorTarget.style.display = "none"
    this.ncDetailsTarget.style.display = "none"

    try {
      const url = `${this.searchUrlValue}?nro_factura=${encodeURIComponent(nroFactura)}&document_type=NCV`
      const response = await fetch(url, {
        headers: { "Accept": "application/json", "X-CSRF-Token": this.csrfToken }
      })
      const data = await response.json()

      this.loadingTarget.style.display = "none"

      if (data.success && data.invoices && data.invoices.length > 0) {
        const nc = data.invoices[0]

        if (nc.already_registered) {
          this.searchErrorTarget.textContent = "Esta nota de crédito ya está registrada en el sistema"
          this.searchErrorTarget.style.display = "block"
          return
        }

        if (nc.document_type !== "NCV") {
          this.searchErrorTarget.textContent = "El documento encontrado no es una Nota de Crédito"
          this.searchErrorTarget.style.display = "block"
          return
        }

        this.displayCreditNote(nc)
      } else {
        this.searchErrorTarget.textContent = data.error || "No se encontró la NC en Colppy"
        this.searchErrorTarget.style.display = "block"
      }
    } catch (error) {
      this.loadingTarget.style.display = "none"
      this.searchErrorTarget.textContent = `Error de conexión: ${error.message}`
      this.searchErrorTarget.style.display = "block"
    }
  }

  displayCreditNote(nc) {
    this.ncNumberTarget.textContent = nc.nro_factura_full || nc.nro_factura
    this.ncTypeTarget.textContent = `NC ${nc.invoice_type}`
    this.ncDateTarget.textContent = nc.date_of_issue || "-"
    const totalPesos = (nc.total_factura_cents / 100).toFixed(2)
    this.ncTotalTarget.textContent = `$${totalPesos}`

    this.colppyInvoiceIdTarget.value = nc.id_factura

    this.ncDetailsTarget.style.display = "block"
    this.updateSubmitState()
  }

  updateSubmitState() {
    if (!this.hasSubmitButtonTarget) return

    const hasNc = this.hasColppyInvoiceIdTarget && this.colppyInvoiceIdTarget.value !== ""
    const hasOriginal = document.getElementById("import_nc_original_invoice_id")?.value !== ""

    this.submitButtonTarget.disabled = !(hasNc && hasOriginal)
  }

  get csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.getAttribute("content") : ""
  }
}
